const intervalDays = 30;
const intervals: { id: number; value: string }[] = [];
for (let interval = 1; interval <= intervalDays; interval++) {
    intervals.push({ id: interval, value: `${interval} Day${interval > 1 ? 's' : ''}` });
}
export default intervals;
